export default "__VITE_ASSET__D50zm_Z8__"